module.exports = __webpack_public_path__ + "img/sergeant-service-icon1.886477a7.png";